// New Product Page JavaScript - Color & Size Variant Selection

// Hide dimensions content immediately (before DOMContentLoaded)
(function() {
  if (document.readyState === 'loading') {
    var style = document.createElement('style');
    style.textContent = '.dimensions-content { display: none !important; visibility: hidden !important; opacity: 0 !important; }';
    document.head.appendChild(style);
  }
})();

document.addEventListener('DOMContentLoaded', function() {
  const productPage = document.querySelector('.product-page-new');
  if (!productPage) return;

  // Show gallery immediately - no waiting for images to prevent flicker
  const featuredImg = productPage.querySelector('.product-page-new__featured-img');
  const imageGallery = productPage.querySelector('.product-page-new__image-gallery');
  
  if (imageGallery) {
    // Show gallery immediately - CSS handles background color during load
    imageGallery.classList.add('loaded');
  }
  
  // Delay lazy image loading until critical images start loading
  // Wait for the 4 main gallery images to start loading first
  const criticalImages = productPage.querySelectorAll('.product-page-new__gallery-img[loading="eager"], .product-page-new__featured-img[loading="eager"]');
  let criticalImagesLoaded = 0;
  const totalCriticalImages = criticalImages.length;
  
  // Count when critical images start loading
  criticalImages.forEach(img => {
    if (img.complete) {
      criticalImagesLoaded++;
    } else {
      img.addEventListener('load', () => {
        criticalImagesLoaded++;
      }, { once: true });
      img.addEventListener('error', () => {
        criticalImagesLoaded++; // Count errors too to not block
      }, { once: true });
    }
  });
  
  // Optimize image loading with Intersection Observer for lazy images
  // Delay lazy image observer until critical images have started loading
  function initLazyImages() {
    if ('IntersectionObserver' in window) {
      const lazyImages = productPage.querySelectorAll('img[loading="lazy"]');
      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            // Trigger load by ensuring src is set
            if (img.dataset.src) {
              img.src = img.dataset.src;
            }
            imageObserver.unobserve(img);
          }
        });
      }, { rootMargin: '100px 0px' }); // Preload 100px before entering viewport
      
      lazyImages.forEach(img => imageObserver.observe(img));
    }
  }
  
  // Start lazy loading after first critical image starts loading or after 200ms
  if (criticalImagesLoaded >= 1 || criticalImages.length === 0) {
    setTimeout(initLazyImages, 200);
  } else {
    // Wait for at least one critical image to start
    const checkInterval = setInterval(() => {
      if (criticalImagesLoaded >= 1) {
        clearInterval(checkInterval);
        setTimeout(initLazyImages, 100);
      }
    }, 50);
    // Fallback: start after 500ms max
    setTimeout(() => {
      clearInterval(checkInterval);
      initLazyImages();
    }, 500);
  }

  const originalProductId = productPage.dataset.productId;
  const originalProductHandle = productPage.dataset.productHandle;
  const originalProductUrl = productPage.dataset.productUrl;
  
  // Store original product data for restoration
  let originalProductData = null;
  // Store current product data for size selection
  let currentProductData = null;
  
  const colorSwatches = document.querySelectorAll('[data-color-swatches] .product-page-new__color-swatch');
  const sizeButtons = document.querySelectorAll('[data-size-selector] .product-page-new__size-btn');
  const productGallery = productPage.querySelector('[data-product-gallery]');
  const productTitle = productPage.querySelector('[data-product-title]');
  const productPrice = productPage.querySelector('[data-product-price]');
  const currentColorName = productPage.querySelector('[data-current-color-name]');
  const productForm = productPage.querySelector('[data-product-form]');
  const variantIdInput = productForm?.querySelector('[data-variant-id]');
  const addToCartBtn = productForm?.querySelector('[data-add-to-cart]');

  let currentVariantId = variantIdInput?.value;
  let selectedSize = null;
  let isLoading = false;
  
  
  // Sync variant ID to ALL forms on the page whenever it changes
  // This ensures sticky bar, main form, and any other forms have the correct variant
  function syncVariantToAllForms() {
    if (!currentVariantId) return;
    
    // Find ALL variant inputs on the page
    const allVariantInputs = document.querySelectorAll('input[name="id"], [data-variant-id]');
    allVariantInputs.forEach(input => {
      if (input.value !== String(currentVariantId)) {
        input.value = currentVariantId;
      }
    });
  }
  
  // Sync on any click anywhere on the page (captures sticky bar clicks too)
  document.addEventListener('click', function(e) {
    // Check if clicking any add to cart button
    const btn = e.target.closest('button[type="submit"], [data-add-to-cart], [data-js-product-add-to-cart], [data-sticky-atc]');
    if (btn) {
      syncVariantToAllForms();
    }
  }, true); // Capture phase - runs before other handlers
  
  // Also handle form submit as backup
  if (productForm && addToCartBtn) {
    productForm.addEventListener('submit', async function(e) {
      // Sync variant ID one more time
      const currentVariantInput = productForm.querySelector('[data-variant-id]') || productForm.querySelector('input[name="id"]');
      if (currentVariantInput && currentVariantId) {
        currentVariantInput.value = currentVariantId;
      }
      
      e.preventDefault();
      e.stopPropagation();
      
      if (addToCartBtn.disabled) return;
      
      // Use currentVariantId as primary source (tracked when size is selected)
      const inputValue = currentVariantInput?.value;
      const variantId = currentVariantId || inputValue;
      
      if (!variantId) {
        return;
      }
      
      // Show loading state with rotating logo
      addToCartBtn.classList.add('working');
      addToCartBtn.disabled = true;
      const buttonText = addToCartBtn.querySelector('.button__text');
      const originalText = buttonText ? buttonText.textContent : addToCartBtn.textContent;
      // Don't change text - logo animation will show instead
      
      // Also sync full-width button
      const fullWidthBtn = document.querySelector('[data-add-to-cart-full-width]');
      if (fullWidthBtn) {
        fullWidthBtn.classList.add('working');
        fullWidthBtn.disabled = true;
      }
      
      try {
        // Add to cart via AJAX
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        const data = await response.json();
        
        if (response.ok) {
          // Update cart count in header
          await updateCartCount();
          
          // Open cart drawer
          const cartDrawer = document.getElementById('site-cart-sidebar');
          if (cartDrawer && typeof cartDrawer.show === 'function') {
            cartDrawer.show();
          } else if (cartDrawer) {
            // Fallback: manually show the drawer
            cartDrawer.style.display = 'block';
            cartDrawer.setAttribute('aria-hidden', 'false');
            document.body.classList.add('drawer-open');
          }
          
          // Dispatch custom event for theme compatibility
          productForm.dispatchEvent(new CustomEvent('add-to-cart', { bubbles: true }));
        } else {
          // Handle error
          console.error('Error adding to cart:', data);
          alert(data.description || 'Unable to add item to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Unable to add item to cart. Please try again.');
      } finally {
        // Reset button state
        addToCartBtn.classList.remove('working');
        addToCartBtn.disabled = false;
        const buttonText = addToCartBtn.querySelector('.button__text');
        if (buttonText) {
          buttonText.textContent = originalText;
        } else {
        addToCartBtn.textContent = originalText;
        }
        
        // Also reset full-width button
        const fullWidthBtn = document.querySelector('[data-add-to-cart-full-width]');
        if (fullWidthBtn) {
          fullWidthBtn.classList.remove('working');
          // Re-enable only if variant is available
          const isAvailable = addToCartBtn.textContent !== 'Sold Out' && !addToCartBtn.disabled;
          fullWidthBtn.disabled = !isAvailable;
        }
      }
    });
  }
  
  // Function to update cart count in header
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Update all cart count elements
      document.querySelectorAll('[data-header-cart-count]').forEach(el => {
        el.textContent = cart.item_count || 0;
      });
      
      // Update cart drawer if it exists
      const cartDrawer = document.getElementById('site-cart-sidebar');
      if (cartDrawer) {
        cartDrawer.setAttribute('data-cart-items', cart.item_count || 0);
        
        // Reload cart drawer content
        try {
          const cartResponse = await fetch('?section_id=helper-cart');
          if (cartResponse.ok) {
            const cartHtml = await cartResponse.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(cartHtml, 'text/html');
            
            const cartForm = doc.getElementById('AjaxCartForm');
            const cartSubtotal = doc.getElementById('AjaxCartSubtotal');
            
            if (cartForm && document.getElementById('AjaxCartForm')) {
              const cartFormElement = document.getElementById('AjaxCartForm');
              cartFormElement.innerHTML = cartForm.innerHTML;
              // Re-initialize cart items - ensure remove handlers are attached
              if (cartFormElement.ajaxifyCartItems && typeof cartFormElement.ajaxifyCartItems === 'function') {
                cartFormElement.ajaxifyCartItems();
              }
            }
            
            if (cartSubtotal && document.getElementById('AjaxCartSubtotal')) {
              document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotal.innerHTML;
            }
          }
        } catch (error) {
          console.error('Error updating cart drawer:', error);
        }
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
  
  // Store original product data on page load
  async function storeOriginalProductData() {
    if (originalProductHandle && !originalProductData) {
      originalProductData = await fetchProductData(originalProductHandle);
      // Ensure the handle and ID are set correctly for comparison
      if (originalProductData) {
        originalProductData.handle = originalProductHandle;
        originalProductData.id = originalProductId;
        // Also set as current product data for initial load
        currentProductData = originalProductData;
      }
    }
    return originalProductData;
  }
  
  // Call it immediately to store original product data
  // Make it a promise so we can await it elsewhere
  const productDataPromise = storeOriginalProductData();
  
  // Prefetch all color variant pages for faster navigation
  function prefetchColorVariants() {
    // Use requestIdleCallback if available for non-blocking prefetch
    const prefetchFn = () => {
    colorSwatches.forEach(swatch => {
      const productUrl = swatch.dataset.productUrl;
      const productHandle = swatch.dataset.productHandle;
      
      if (productUrl) {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = productUrl;
        document.head.appendChild(link);
      } else if (productHandle) {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = `/products/${productHandle}`;
        document.head.appendChild(link);
      }
    });
    };
    
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetchFn, { timeout: 2000 });
    } else {
      setTimeout(prefetchFn, 1000);
    }
  }
  
  // Prefetch after page is fully loaded to not block initial render
  if (document.readyState === 'complete') {
    prefetchColorVariants();
  } else {
    window.addEventListener('load', prefetchColorVariants, { once: true });
  }
  
  // Once product data is loaded, store it
  productDataPromise.then(data => {
    if (data && !currentProductData) {
      currentProductData = data;
    }
  }).catch(() => {});

  // Load product info sections in order to prevent layout jumps - top to bottom
  function initSequentialProductInfoLoading() {
    const infoContainer = productPage.querySelector('.product-page-new__info');
    if (!infoContainer) return;
    
    // Get all direct children in DOM order (top to bottom)
    const allChildren = Array.from(infoContainer.children);
    
    // Filter to only the main sections we want to load sequentially (in DOM order - top to bottom)
    const sectionsToLoad = allChildren.filter(child => {
      if (!child) return false;
      
      // Skip elements that are permanently hidden
      const computedStyle = window.getComputedStyle(child);
      if (computedStyle.display === 'none') return false;
      
      const tagName = child.tagName;
      const classList = child.classList;
      
      // Include all main content sections in order: title, colors, size, material, price, button, description, etc.
      return (
        classList.contains('product-page-new__title-row') ||
        classList.contains('product-page-new__section') ||
        classList.contains('product-page-new__price-wrapper') ||
        (tagName === 'FORM' && classList.contains('product-page-new__section'))
      );
    });
    
    if (sectionsToLoad.length === 0) return;
    
    // Hide all sections initially with opacity 0 (keeps layout space, prevents flicker)
    sectionsToLoad.forEach(section => {
      section.style.opacity = '0';
      section.style.transition = 'opacity 0.3s ease-in-out';
    });
    
    // Show sections sequentially from top to bottom
    let index = 0;
    const delay = 80; // 80ms between each section for smooth sequential reveal
    
    function showNextSection() {
      if (index < sectionsToLoad.length) {
        const section = sectionsToLoad[index];
        if (section) {
          // Use requestAnimationFrame for smooth rendering
          requestAnimationFrame(() => {
            section.style.opacity = '1';
            section.classList.add('info-section-visible');
          });
        }
        index++;
        
        if (index < sectionsToLoad.length) {
          setTimeout(showNextSection, delay);
        }
      }
    }
    
    // Start showing sections after brief delay to ensure DOM is ready
    // Use requestAnimationFrame to ensure smooth rendering
    requestAnimationFrame(() => {
      setTimeout(() => {
        showNextSection();
      }, 120);
    });
  }
  
  // Initialize sequential loading - run early to prevent flicker
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initSequentialProductInfoLoading();
    });
  } else {
    // DOM already loaded, run immediately
    initSequentialProductInfoLoading();
  }

  // Expandable sections - accordion behavior (only one open at a time)
  const expandables = document.querySelectorAll('.product-page-new__expandable');
  
  // Function to ensure product info bottom is always at minimum aligned with gallery bottom
  // Disabled - no position adjustment needed
  function adjustStickyBarPosition() {
    // Do nothing - bar stays at bottom: 0
      return;
    }
    
  // Watch for expandable content changes using MutationObserver (disabled position adjustment)
  const expandableObserver = new MutationObserver(() => {
    // Position adjustment disabled
    return;
  });
  
  expandables.forEach((expandable, index) => {
    // Observe changes to the expandable content
    const contentElement = expandable.querySelector('.product-page-new__expandable-content');
    if (contentElement) {
      expandableObserver.observe(contentElement, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: true,
        subtree: true
      });
      
      // Mark content as ready if expandable is already active (prevents flash on load)
      if (expandable.classList.contains('active')) {
        contentElement.classList.add('content-ready');
        // Show dimensions content after 0.4 second delay
        const dimensionsContent = contentElement.querySelector('[data-dimensions-content]');
        if (dimensionsContent) {
          // Hide placeholder when dimensions load
          const placeholder = contentElement.querySelector('.dimensions-content-placeholder');
          setTimeout(() => {
            dimensionsContent.classList.add('loaded');
            if (placeholder) {
              placeholder.classList.add('hidden');
            }
          }, 400);
        }
      }
    }
    
    // Make entire block clickable
    // Only listen for clicks on the header, not the entire expandable
    const header = expandable.querySelector('.product-page-new__expandable-header');
    if (!header) return;
    
    // Check if this is Size Selection - keep it always open and non-collapsible
    const isSizeSelection = expandable.dataset.sizeSelection === 'true';
    
    if (isSizeSelection) {
      // Keep Size Selection always open - but add active class immediately (synchronously)
      expandable.classList.add('active');
      // Mark content as ready immediately to prevent flash
      if (contentElement) {
        // Remove display: none immediately (synchronously) before adding content-ready
        contentElement.style.removeProperty('display');
        contentElement.classList.add('content-ready');
        // Show dimensions content after 0.4 second delay
        const dimensionsContent = contentElement.querySelector('[data-dimensions-content]');
        if (dimensionsContent) {
          // Hide placeholder when dimensions load
          const placeholder = contentElement.querySelector('.dimensions-content-placeholder');
          setTimeout(() => {
            dimensionsContent.classList.add('loaded');
            if (placeholder) {
              placeholder.classList.add('hidden');
            }
          }, 400);
        }
      }
      // Skip adding click handler - CSS handles the rest
      return;
    }
    
    header.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isActive = expandable.classList.contains('active');
      
      // Close all other expandables (except Size Selection)
      expandables.forEach(other => {
        const isOtherSizeSelection = other.dataset.sizeSelection === 'true';
        if (other !== expandable && !isOtherSizeSelection) {
          other.classList.remove('active');
        }
      });
      
      // Toggle current expandable
      if (isActive) {
        expandable.classList.remove('active');
      } else {
        expandable.classList.add('active');
        // Mark content as ready when expanding
        const contentEl = expandable.querySelector('.product-page-new__expandable-content');
        if (contentEl) {
          requestAnimationFrame(() => {
            contentEl.classList.add('content-ready');
          });
        }
      }
      
      // Position adjustment disabled - bar stays fixed at bottom
    });
  });
  
  // Position adjustment disabled - bar stays fixed at bottom
  
  // Store reference to the function so it can be called from other scopes
  window.adjustStickyBarPosition = adjustStickyBarPosition;

  // Wishlist toggle
  const wishlistBtn = document.querySelector('.product-page-new__wishlist');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', (e) => {
      e.preventDefault();
      wishlistBtn.classList.toggle('active');
    });
  }

  // Read more functionality
  function initReadMore() {
    const readMore = document.querySelector('.product-page-new__read-more');
    const description = document.querySelector('.product-page-new__description');
    if (readMore && description) {
      // Check if description needs read more (if content is taller than max-height)
      const checkIfReadMoreNeeded = () => {
        // Temporarily remove max-height to measure full height
        const originalMaxHeight = description.style.maxHeight;
        description.style.maxHeight = 'none';
        const fullHeight = description.scrollHeight;
        description.style.maxHeight = originalMaxHeight;
        
        if (fullHeight > 150) {
          readMore.style.display = 'block';
        } else {
          readMore.style.display = 'none';
        }
      };
      
      // Check on load and after a short delay to ensure content is rendered
      checkIfReadMoreNeeded();
      setTimeout(checkIfReadMoreNeeded, 100);
      
      // Remove existing event listener if any
      const newReadMore = readMore.cloneNode(true);
      readMore.parentNode.replaceChild(newReadMore, readMore);
      
      newReadMore.addEventListener('click', (e) => {
        e.preventDefault();
        if (description.classList.contains('expanded')) {
          description.classList.remove('expanded');
          newReadMore.textContent = 'Read more';
        } else {
          description.classList.add('expanded');
          newReadMore.textContent = 'Read less';
        }
      });
    }
  }
  
  // Initialize read more on page load
  initReadMore();

  // Gallery images are now just static images - no click functionality

  // Fetch product data via AJAX
  async function fetchProductData(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) throw new Error('Product not found');
      const productData = await response.json();
      
      // Extract design from handle (format: {color}-{design})
      const handleParts = productHandle.split('-');
      if (handleParts.length > 1) {
        productData.design = handleParts.slice(1).join('-'); // Everything after first part is design
        productData.color = handleParts[0]; // First part is color
      }
      
      return productData;
    } catch (error) {
      console.error('Error fetching product:', error);
      return null;
    }
  }

  // Update product page content
  function updateProductContent(productData) {
    if (!productData) return;
    
    // Store current product data for size selection (ensures correct color images)
    currentProductData = productData;

    // Update product ID
    const productIdEl = productPage.querySelector('.product-page-new__id');
    if (productIdEl) {
      productIdEl.textContent = productData.variants[0]?.sku || productData.id;
    }

    // Update title - show only design name (not color)
    if (productTitle) {
      // Extract design from handle (format: {color}-{design})
      // Design is the LAST part after splitting by hyphen
      const handleParts = productData.handle.split('-');
      if (handleParts.length > 1) {
        // Get the last part (design), not everything after first part
        const design = handleParts[handleParts.length - 1];
        // Capitalize first letter of each word if design has multiple parts
        const designParts = design.split('-');
        const designName = designParts.map(word => 
          word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ');
        productTitle.textContent = designName;
      } else {
        // Fallback: try to extract from product title (remove color)
        const titleParts = productData.title.split(' ');
        if (titleParts.length > 1) {
          // Assume first word is color, rest is design
          productTitle.textContent = titleParts.slice(1).join(' ');
        } else {
          productTitle.textContent = productData.title;
        }
      }
    }

    // Update current color name
    if (currentColorName) {
      let colorName = '';
      
      // Try to get color from product options first
      if (productData.options) {
        const colorOption = productData.options.find(opt => 
          opt.name.toLowerCase().includes('color') || 
          opt.name.toLowerCase().includes('colour')
        );
        if (colorOption && colorOption.values && colorOption.values.length > 0) {
          colorName = colorOption.values[0];
        }
      }
      
      // If no color option, extract from handle (format: {color}-{design})
      if (!colorName && productData.handle) {
        const handleParts = productData.handle.split('-');
        if (handleParts.length > 0) {
          // Get the color (first part)
          const color = handleParts[0];
          // Capitalize first letter of each word
          colorName = color.split('-').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
          ).join(' ');
        }
      }
      
      // Fallback: try to get from product title (first two words usually contain color)
      if (!colorName && productData.title) {
        const titleParts = productData.title.split(' ');
        if (titleParts.length >= 2) {
          colorName = titleParts[0] + ' ' + titleParts[1];
        } else if (titleParts.length >= 1) {
          colorName = titleParts[0];
        }
      }
      
      currentColorName.textContent = colorName || '';
    }

    // Update price
    const firstVariant = productData.variants.find(v => v.available) || productData.variants[0];
    if (productPrice && firstVariant) {
      productPrice.textContent = formatMoney(firstVariant.price);
    }

    // Update gallery images
    if (productGallery && productData.images && productData.images.length > 0) {
      const mainImageEl = productGallery.querySelector('.product-page-new__featured-img');
      const galleryContainer = productGallery.querySelector('.product-page-new__image-gallery');
      
      // Update main image with smooth transition
      if (mainImageEl) {
        // Shopify product JSON API returns full image URLs
        const mainImageUrl = productData.images[0];
        
        // Preload the new image before switching
        const newImg = new Image();
        newImg.onload = () => {
          // Once loaded, fade out old image, swap src, then fade in
          mainImageEl.style.opacity = '0';
          mainImageEl.style.transition = 'opacity 0.2s ease-in-out';
          
          setTimeout(() => {
            mainImageEl.src = mainImageUrl;
            mainImageEl.alt = productData.title;
            mainImageEl.style.opacity = '1';
          }, 100);
        };
        newImg.src = mainImageUrl;
      }

      // Update gallery images - skip first image, show next 4 images, full size
      if (galleryContainer) {
        // Fade out existing gallery items
        const existingItems = galleryContainer.querySelectorAll('.product-page-new__gallery-item');
        existingItems.forEach(item => {
          item.style.opacity = '0';
          item.style.transition = 'opacity 0.2s ease-in-out';
        });
        
        // Wait for fade out, then update
        setTimeout(() => {
          galleryContainer.innerHTML = '';
          // Skip first image (index 0) and show next 4 images (indices 1-4)
          const imagesToShow = productData.images.slice(1, 5);
          imagesToShow.forEach((imageUrl, index) => {
            const galleryItem = document.createElement('div');
            galleryItem.className = 'product-page-new__gallery-item';
            galleryItem.style.opacity = '0';
            galleryItem.style.transition = 'opacity 0.3s ease-in-out';
            
            const img = document.createElement('img');
            // Use full size image (1200px) instead of thumbnail
            img.src = imageUrl;
            img.alt = productData.title;
            img.className = 'product-page-new__gallery-img';
            img.loading = 'lazy';
            // No click functionality - just static images
            
            galleryItem.appendChild(img);
            galleryContainer.appendChild(galleryItem);
            
            // Fade in after image loads
            img.onload = () => {
              requestAnimationFrame(() => {
                galleryItem.style.opacity = '1';
              });
            };
          });
        }, 200);
      } else if (productData.images.length > 1) {
        // Create gallery container if it doesn't exist
        const newGalleryContainer = document.createElement('div');
        newGalleryContainer.className = 'product-page-new__image-gallery';
        // Skip first image (index 0) and show next 4 images (indices 1-4)
        const imagesToShow = productData.images.slice(1, 5);
        imagesToShow.forEach((imageUrl, index) => {
          const galleryItem = document.createElement('div');
          galleryItem.className = 'product-page-new__gallery-item';
          galleryItem.style.opacity = '0';
          galleryItem.style.transition = 'opacity 0.3s ease-in-out';
          
          const img = document.createElement('img');
          // Use full size image (1200px) instead of thumbnail
          img.src = imageUrl;
          img.alt = productData.title;
          img.className = 'product-page-new__gallery-img';
          img.loading = 'lazy';
          // No click functionality - just static images
          
          galleryItem.appendChild(img);
          newGalleryContainer.appendChild(galleryItem);
          
          // Fade in after image loads
          img.onload = () => {
            requestAnimationFrame(() => {
              galleryItem.style.opacity = '1';
            });
          };
        });
        productGallery.appendChild(newGalleryContainer);
      }
    }

    // Update size buttons
    if (sizeButtons.length > 0 && productData.options) {
      const sizeOption = productData.options.find(opt => 
        !opt.name.toLowerCase().includes('color') && 
        !opt.name.toLowerCase().includes('colour') &&
        !opt.name.toLowerCase().includes('design')
      );
      
      if (sizeOption) {
        const sizeContainer = productPage.querySelector('[data-size-selector]');
        if (sizeContainer) {
          const sizesContainer = sizeContainer.querySelector('.product-page-new__sizes');
          if (sizesContainer) {
            sizesContainer.innerHTML = '';
            
            // Find the index of the previously selected size, or default to "M" (medium) on initial load
            let defaultSizeIndex = 0;
            if (selectedSize && sizeOption.values.includes(selectedSize)) {
              // Use previously selected size if available
              defaultSizeIndex = sizeOption.values.indexOf(selectedSize);
            } else if (!selectedSize) {
              // On initial load, try to find "M" (medium) size
              const mediumIndex = sizeOption.values.findIndex(val => 
                val.toString().toUpperCase() === 'M' || 
                val.toString().toUpperCase() === 'MEDIUM' ||
                val.toString().toUpperCase().includes('M')
              );
              if (mediumIndex >= 0) {
                defaultSizeIndex = mediumIndex;
              } else {
                // Fallback to first size if "M" not found
                defaultSizeIndex = 0;
              }
            }
            
            sizeOption.values.forEach((value, index) => {
              const sizeBtn = document.createElement('button');
              sizeBtn.type = 'button';
              sizeBtn.className = 'product-page-new__size-btn';
              if (index === defaultSizeIndex) {
                sizeBtn.classList.add('active');
                // Always set selectedSize to the default (first size on initial load)
                selectedSize = value;
              }
              sizeBtn.textContent = value;
              sizeBtn.setAttribute('data-size-value', value);
              sizeBtn.setAttribute('data-option-name', sizeOption.name);
              sizeBtn.setAttribute('data-size-index', index);
              sizeBtn.addEventListener('click', () => {
                // Use currentProductData if available, otherwise use productData from closure
                const dataToUse = currentProductData || productData;
                handleSizeSelection(value, sizeOption.name, dataToUse);
                updateSizeImage(index, dataToUse);
              });
              sizesContainer.appendChild(sizeBtn);
            });
            
            // Update size image and variant for the selected size (always do this, even on initial load)
            if (defaultSizeIndex >= 0) {
              updateSizeImage(defaultSizeIndex, productData);
              // Also update the variant ID and form for the default size
              const defaultSizeValue = sizeOption.values[defaultSizeIndex];
              const sizeOptionIndex = productData.options.findIndex(opt => opt.name === sizeOption.name);
              if (sizeOptionIndex >= 0) {
                const matchingVariant = productData.variants.find(variant => 
                  variant.options[sizeOptionIndex] === defaultSizeValue
                );
                if (matchingVariant) {
                  currentVariantId = matchingVariant.id;
                  // Query fresh to ensure correct element
                  const freshForm = document.querySelector('[data-product-form]');
                  const freshInput = freshForm?.querySelector('[data-variant-id]') || freshForm?.querySelector('input[name="id"]');
                  if (freshInput) {
                    freshInput.value = matchingVariant.id;
                  }
                  if (productPrice) {
                    productPrice.textContent = formatMoney(matchingVariant.price);
                  }
                  if (addToCartBtn) {
                    const isAvailable = matchingVariant.available !== false;
                    addToCartBtn.disabled = !isAvailable;
                    const buttonText = addToCartBtn.querySelector('.button__text');
                    if (buttonText) {
                      buttonText.textContent = isAvailable ? 'Place in Cart' : 'Sold Out';
                    } else {
                      const buttonText = addToCartBtn.querySelector('.button__text');
                      if (buttonText) {
                        buttonText.textContent = isAvailable ? 'Place in Cart' : 'Sold Out';
                      } else {
                        const buttonText = addToCartBtn.querySelector('.button__text');
      if (buttonText) {
        buttonText.textContent = isAvailable ? 'Place in Cart' : 'Sold Out';
      } else {
        const buttonText = addToCartBtn.querySelector('.button__text');
        if (buttonText) {
          buttonText.textContent = isAvailable ? 'Place in Cart' : 'Sold Out';
        } else {
                    addToCartBtn.textContent = isAvailable ? 'Place in Cart' : 'Sold Out';
        }
      }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    // Update variant ID and form
    if (firstVariant) {
      currentVariantId = firstVariant.id;
      // Query fresh to ensure correct element
      const freshForm = document.querySelector('[data-product-form]');
      const freshInput = freshForm?.querySelector('[data-variant-id]') || freshForm?.querySelector('input[name="id"]');
      if (freshInput) {
        freshInput.value = firstVariant.id;
      }
    }

    // Update add to cart button
    if (addToCartBtn) {
      const isAvailable = firstVariant?.available !== false;
      addToCartBtn.disabled = !isAvailable;
      const buttonText = addToCartBtn.querySelector('.button__text');
      if (buttonText) {
        buttonText.textContent = isAvailable ? 'Place in Cart' : 'Sold Out';
      } else {
        const buttonText = addToCartBtn.querySelector('.button__text');
        if (buttonText) {
          buttonText.textContent = isAvailable ? 'Place in Cart' : 'Sold Out';
        } else {
      addToCartBtn.textContent = isAvailable ? 'Place in Cart' : 'Sold Out';
        }
      }
    }

    // Don't update URL - keep the same URL while updating product content
    // URL stays the same, but product info is updated dynamically

    // Update page data attributes to track current product
    // But keep original product ID/handle for reference
    productPage.dataset.currentProductId = productData.id;
    productPage.dataset.currentProductHandle = productData.handle;
  }

  // Handle size selection
  async function handleSizeSelection(sizeValue, optionName, productData) {
    // Use currentProductData if productData is not provided
    let dataToUse = productData || currentProductData;
    
    // If no data available, wait for original product data to load or fetch it
    if (!dataToUse) {
      // First, try to wait for original product data if it's still loading
      if (!originalProductData && originalProductHandle) {
        await storeOriginalProductData();
        dataToUse = currentProductData;
      }
      
      // If still no data, fetch current product data
      if (!dataToUse) {
        const currentHandle = productPage.dataset.currentProductHandle || productPage.dataset.productHandle;
        const fetchedData = await fetchProductData(currentHandle);
        if (fetchedData) {
          currentProductData = fetchedData;
          dataToUse = fetchedData;
        }
      }
    }
    
    // If we still have data, proceed with size selection
    if (dataToUse) {
      selectSizeInProduct(sizeValue, optionName, dataToUse);
    } else {
    }
  }

  function selectSizeInProduct(sizeValue, optionName, productData, skipImageUpdate = false) {
    const dataToUse = currentProductData || productData;
    
    if (!dataToUse || !dataToUse.variants) {
      return;
    }
    
    selectedSize = sizeValue;

    // Update size button active state
    const sizeButtons = document.querySelectorAll('[data-size-selector] .product-page-new__size-btn');
    sizeButtons.forEach(btn => {
      btn.classList.remove('active');
      if (btn.dataset.sizeValue === sizeValue) {
        btn.classList.add('active');
        // Only update image if not called from triggerSizeSelection (which handles it separately)
        if (!skipImageUpdate) {
        updateSizeImage(btn.dataset.sizeIndex, dataToUse);
        }
      }
    });

    // Find matching variant
    let matchingVariant = null;
    
    // First try exact match on any option
    matchingVariant = dataToUse.variants.find(variant => 
      variant.options.includes(sizeValue)
    );
    
    // If no exact match, try normalized comparison
    if (!matchingVariant) {
      const normalizeSize = (size) => {
        if (!size) return '';
        return size.toString().replace(/[\[\]"]/g, '').trim().toLowerCase();
      };
      const normalizedSizeValue = normalizeSize(sizeValue);
      
      matchingVariant = dataToUse.variants.find(variant => 
        variant.options.some(opt => normalizeSize(opt) === normalizedSizeValue)
      );
    }

    if (matchingVariant) {
      currentVariantId = matchingVariant.id;
      
      // Update the hidden input
      const currentForm = document.querySelector('[data-product-form]');
      const currentVariantInput = currentForm?.querySelector('[data-variant-id]') || currentForm?.querySelector('input[name="id"]');
      
      if (currentVariantInput) {
        currentVariantInput.value = matchingVariant.id;
      }
      
      // Update price
      let priceEl = productPage.querySelector('[data-product-price]');
      if (!priceEl) priceEl = productPrice;
      
      if (priceEl) {
        const formattedPrice = formatMoney(matchingVariant.price);
        priceEl.textContent = formattedPrice;
      }
          
      // Update button state
      if (addToCartBtn) {
        const isAvailable = matchingVariant.available !== false;
        addToCartBtn.disabled = !isAvailable;
        const buttonText = addToCartBtn.querySelector('.button__text');
      if (buttonText) {
        buttonText.textContent = isAvailable ? 'Place in Cart' : 'Sold Out';
      } else {
        const buttonText = addToCartBtn.querySelector('.button__text');
        if (buttonText) {
          buttonText.textContent = isAvailable ? 'Place in Cart' : 'Sold Out';
        } else {
          addToCartBtn.textContent = isAvailable ? 'Place in Cart' : 'Sold Out';
        }
      }
      }
    }
    
    // Update dimension block selection to match
    if (typeof updateDimensionBlockSelection === 'function') {
      updateDimensionBlockSelection(sizeValue);
    }
  }
  
  // Expose size selection function globally for dimension blocks
  // Debounce variant selection to prevent flicker
  let sizeSelectionTimeout = null;
  let pendingSizeSelection = null;
  
  window.triggerSizeSelection = async function(sizeValue, optionName, sizeIndex) {
    // Clear any pending selection
    if (sizeSelectionTimeout) {
      clearTimeout(sizeSelectionTimeout);
      sizeSelectionTimeout = null;
    }
    
    // Get product data
    let dataToUse = currentProductData;
    
    if (!dataToUse) {
      try {
        dataToUse = await productDataPromise;
        if (dataToUse) {
          currentProductData = dataToUse;
        }
      } catch (e) {}
    }
    
    if (!dataToUse) {
      const currentHandle = productPage.dataset.currentProductHandle || productPage.dataset.productHandle;
      if (currentHandle) {
        try {
          dataToUse = await fetchProductData(currentHandle);
          if (dataToUse) {
            currentProductData = dataToUse;
          }
        } catch (e) {}
      }
    }
    
    // Select the size and update variant - instant, no delays
    if (dataToUse) {
      // Skip image update in selectSizeInProduct since we handle it separately
      selectSizeInProduct(sizeValue, optionName, dataToUse, true);
      if (sizeIndex !== undefined) {
        updateSizeImage(parseInt(sizeIndex), dataToUse);
      }
    }
  };

  // Track if we're programmatically scrolling (from button click)
  let isProgrammaticScroll = false;
  let scrollAnimationId = null;
  
  // Update size gallery - scroll to selected size
  function updateSizeImage(sizeIndex, productData) {
    const sizeGallery = productPage.querySelector('[data-size-gallery]');
    const sizeGalleryTrack = productPage.querySelector('[data-size-gallery-track]');
    
    if (!sizeGallery || !sizeGalleryTrack) {
      return;
    }
    
    const sizeIndexNum = parseInt(sizeIndex) || 0;
    const galleryItems = sizeGalleryTrack.querySelectorAll('[data-size-gallery-item]');
    
    if (galleryItems.length === 0) return;
    
    // Cancel any ongoing scroll animation
    if (scrollAnimationId) {
      cancelAnimationFrame(scrollAnimationId);
      scrollAnimationId = null;
    }
    
    // Scroll to the correct item
    const targetItem = galleryItems[sizeIndexNum];
    if (targetItem) {
      const itemWidth = sizeGalleryTrack.offsetWidth;
      const targetScroll = sizeIndexNum * itemWidth;
      
      // Set flag to prevent scroll handler from updating buttons
      isProgrammaticScroll = true;
      
      // If already at target, update immediately without animation
      if (Math.abs(sizeGalleryTrack.scrollLeft - targetScroll) < 5) {
        sizeGalleryTrack.scrollLeft = targetScroll;
        // Update states immediately
        galleryItems.forEach((item, index) => {
          item.classList.toggle('active', index === sizeIndexNum);
        });
        isProgrammaticScroll = false;
        return;
      }
      
      // Update active states immediately to prevent flicker
      galleryItems.forEach((item, index) => {
        item.classList.toggle('active', index === sizeIndexNum);
      });
      
      // Instant scroll - no animation
      sizeGalleryTrack.scrollLeft = targetScroll;
      
      // Reset flag immediately
      isProgrammaticScroll = false;
      scrollAnimationId = null;
    }
  }
  
  // Initialize size gallery swipe and interactions - use native scroll like main gallery
  function initSizeGallery() {
    const sizeGallery = productPage.querySelector('[data-size-gallery]');
    const sizeGalleryTrack = productPage.querySelector('[data-size-gallery-track]');
    
    if (!sizeGallery || !sizeGalleryTrack) return;
    
    const galleryItems = sizeGalleryTrack.querySelectorAll('[data-size-gallery-item]');
    const sizeButtons = document.querySelectorAll('[data-size-selector] .product-page-new__size-btn');
    const prevArrow = sizeGallery.querySelector('[data-size-arrow="prev"]');
    const nextArrow = sizeGallery.querySelector('[data-size-arrow="next"]');
    
    if (galleryItems.length === 0) return;
    
    // Track last active index to avoid duplicate triggers
    let lastActiveIndex = 0;
    
    // Update arrow states based on scroll position
    function updateArrowStates() {
      // Hide arrows if only one item
      if (galleryItems.length <= 1) {
        if (prevArrow) prevArrow.style.display = 'none';
        if (nextArrow) nextArrow.style.display = 'none';
          return;
        }
        
      // Show arrows if multiple items
      if (prevArrow) prevArrow.style.display = 'flex';
      if (nextArrow) nextArrow.style.display = 'flex';
      
      const scrollLeft = sizeGalleryTrack.scrollLeft;
      const itemWidth = sizeGalleryTrack.offsetWidth;
      const currentIndex = Math.round(scrollLeft / itemWidth);
      
      if (prevArrow) {
        prevArrow.disabled = currentIndex === 0;
      }
      if (nextArrow) {
        nextArrow.disabled = currentIndex >= galleryItems.length - 1;
      }
    }
    
    // Navigate to previous/next item
    function navigateGallery(direction) {
      const itemWidth = sizeGalleryTrack.offsetWidth;
      const currentScroll = sizeGalleryTrack.scrollLeft;
      const currentIndex = Math.round(currentScroll / itemWidth);
      
      let targetIndex;
      if (direction === 'prev') {
        targetIndex = Math.max(0, currentIndex - 1);
      } else {
        targetIndex = Math.min(galleryItems.length - 1, currentIndex + 1);
      }
      
      // Set flag to prevent scroll handler from updating buttons during arrow navigation
      isProgrammaticScroll = true;
      
      // Instant scroll - no animation
      sizeGalleryTrack.scrollLeft = targetIndex * itemWidth;
      
      // Trigger variant selection immediately
      if (sizeButtons[targetIndex]) {
        const btn = sizeButtons[targetIndex];
        const sizeValue = btn.dataset.sizeValue;
        const optionName = btn.dataset.optionName;
        
        if (window.triggerSizeSelection) {
          window.triggerSizeSelection(sizeValue, optionName, targetIndex);
        }
      }
      
      // Reset flag immediately
      isProgrammaticScroll = false;
    }
    
    // Arrow click handlers
    if (prevArrow) {
      prevArrow.addEventListener('click', () => {
        navigateGallery('prev');
      });
    }
    
    if (nextArrow) {
      nextArrow.addEventListener('click', () => {
        navigateGallery('next');
      });
    }
    
    // On mobile, swiping is disabled - navigation via arrows only
    // Only add scroll listener on desktop (not mobile)
    if (!isMobileView()) {
      // Update slider on scroll - desktop only
      sizeGalleryTrack.addEventListener('scroll', () => {
        // Skip updates during programmatic scroll (from button click)
        if (isProgrammaticScroll) return;
        
        const scrollLeftPos = sizeGalleryTrack.scrollLeft;
        const itemWidth = sizeGalleryTrack.offsetWidth;
        const maxScroll = sizeGalleryTrack.scrollWidth - itemWidth;
        const activeIndex = Math.round(scrollLeftPos / itemWidth);
        
        // Update arrow states
        updateArrowStates();
        
        // Update gallery items active state
        galleryItems.forEach((item, index) => {
          item.classList.toggle('active', index === activeIndex);
        });
        
        // Update size button active state when scrolling
        sizeButtons.forEach((btn, index) => {
          btn.classList.toggle('active', index === activeIndex);
        });
        
        // Trigger variant selection when scroll lands on a new size
        if (activeIndex !== lastActiveIndex && sizeButtons[activeIndex]) {
          lastActiveIndex = activeIndex;
          const btn = sizeButtons[activeIndex];
          const sizeValue = btn.dataset.sizeValue;
          const optionName = btn.dataset.optionName;
          
          // Trigger the variant selection (updates price, cart, etc.)
          if (window.triggerSizeSelection) {
            window.triggerSizeSelection(sizeValue, optionName, activeIndex);
          }
        }
      }, { passive: true });
      
      // Allow vertical scrolling to pass through to page on desktop
      // Only handle horizontal scroll for gallery navigation
      sizeGalleryTrack.addEventListener('wheel', (e) => {
        // Only prevent default if scrolling horizontally
        // Allow vertical scroll to pass through to page
        const isHorizontalScroll = Math.abs(e.deltaX) > Math.abs(e.deltaY);
        
        if (!isHorizontalScroll) {
          // This is a vertical scroll - allow it to pass through to page
          // Don't prevent default, let the page scroll
      return;
    }
    
        // This is a horizontal scroll - allow it for gallery navigation
        // Don't prevent default here either, let the browser handle it naturally
      }, { passive: true });
    }
    
    // Initial arrow state
    updateArrowStates();
    
    // Click on gallery item to open lightbox
    galleryItems.forEach(item => {
      item.addEventListener('click', (e) => {
        const img = item.querySelector('img');
        if (img && img.src) {
          openSizeImageLightbox(img.src);
        }
      });
    });
  }
  
  // Open lightbox for size image
  function openSizeImageLightbox(imageSrc) {
    let lightbox = document.querySelector('.size-image-lightbox');
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'size-image-lightbox';
      lightbox.innerHTML = `
        <button class="size-image-lightbox__close" aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor"/>
          </svg>
        </button>
        <div class="size-image-lightbox__image-container">
          <img class="size-image-lightbox__image" src="" alt="Size guide">
        </div>
        <div class="size-image-lightbox__zoom-hint">Click or scroll to zoom • Drag to pan</div>
      `;
      document.body.appendChild(lightbox);
      
      const lightboxImg = lightbox.querySelector('.size-image-lightbox__image');
      const imageContainer = lightbox.querySelector('.size-image-lightbox__image-container');
      
      let scale = 1;
      let translateX = 0;
      let translateY = 0;
      let isDragging = false;
      let startX = 0;
      let startY = 0;
      
      function updateTransform() {
        lightboxImg.style.transform = `scale(${scale}) translate(${translateX}px, ${translateY}px)`;
      }
      
      function resetZoom() {
        scale = 1;
        translateX = 0;
        translateY = 0;
        lightboxImg.classList.remove('zoomed');
        updateTransform();
      }
      
      // Click to toggle zoom
      lightboxImg.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (scale === 1) {
          scale = 2.5;
          lightboxImg.classList.add('zoomed');
          const rect = lightboxImg.getBoundingClientRect();
          const clickX = (e.clientX - rect.left) / rect.width - 0.5;
          const clickY = (e.clientY - rect.top) / rect.height - 0.5;
          translateX = -clickX * 100;
          translateY = -clickY * 100;
        } else {
          resetZoom();
        }
        updateTransform();
      });
      
      // Scroll to zoom (Ctrl/Cmd + scroll) or pan when zoomed (scroll normally)
      imageContainer.addEventListener('wheel', (e) => {
        // If Ctrl/Cmd is held, zoom
        if (e.ctrlKey || e.metaKey) {
          e.preventDefault();
          const delta = e.deltaY > 0 ? -0.3 : 0.3;
          const newScale = Math.max(1, Math.min(5, scale + delta));
          
          if (newScale === 1) {
            resetZoom();
          } else {
            scale = newScale;
            lightboxImg.classList.add('zoomed');
          }
          updateTransform();
        } else if (scale > 1) {
          // When zoomed, allow scrolling to pan the image
          e.preventDefault();
          const scrollSpeed = 0.5;
          translateX -= e.deltaX * scrollSpeed;
          translateY -= e.deltaY * scrollSpeed;
          updateTransform();
        }
        // If not zoomed and no modifier keys, allow normal scrolling (don't prevent default)
      }, { passive: false });
      
      // Drag to pan when zoomed
      lightboxImg.addEventListener('mousedown', (e) => {
        if (scale > 1) {
          isDragging = true;
          startX = e.clientX - translateX;
          startY = e.clientY - translateY;
          e.preventDefault();
        }
      });
      
      document.addEventListener('mousemove', (e) => {
        if (isDragging && scale > 1) {
          translateX = e.clientX - startX;
          translateY = e.clientY - startY;
          updateTransform();
        }
      });
      
      document.addEventListener('mouseup', () => {
        isDragging = false;
      });
      
      // Close on click anywhere except the image itself
      lightbox.addEventListener('click', (e) => {
        // Don't close if clicking on image, close button, or zoom hint
        const clickedImage = e.target.closest('.size-image-lightbox__image');
        const clickedClose = e.target.closest('.size-image-lightbox__close');
        const clickedHint = e.target.closest('.size-image-lightbox__zoom-hint');
        
        if (clickedClose) {
          // Close button clicked
          lightbox.classList.remove('active');
          document.body.style.overflow = '';
          resetZoom();
        } else if (!clickedImage && !clickedHint) {
          // Clicking on background, container, etc. - close the lightbox
          lightbox.classList.remove('active');
          document.body.style.overflow = '';
          resetZoom();
        }
      });
      
      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && lightbox.classList.contains('active')) {
          lightbox.classList.remove('active');
          document.body.style.overflow = '';
          resetZoom();
        }
      });
    }
    
    const lightboxImg = lightbox.querySelector('.size-image-lightbox__image');
    // Get full resolution image
    const imgSrc = imageSrc.replace(/_\d+x\d+/, '').replace(/width=\d+/, 'width=1200');
    lightboxImg.src = imgSrc;
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  // Main Gallery Lightbox with Swipe Support
  function initMainGalleryLightbox() {
    const mainImage = productPage.querySelector('.product-page-new__featured-img');
    const galleryItems = productPage.querySelectorAll('.product-page-new__gallery-item');
    const imageGallery = productPage.querySelector('.product-page-new__image-gallery');
    
    // Collect all image sources (main image + gallery items)
    function getAllGalleryImages() {
      const images = [];
      
      // Add main featured image
      if (mainImage && mainImage.src) {
        images.push({
          src: mainImage.src.replace(/_\d+x\d+/, '').replace(/width=\d+/, 'width=1200'),
          alt: mainImage.alt || 'Product image'
        });
      }
      
      // Add gallery item images (skip the featured item which is already included)
      galleryItems.forEach(item => {
        // Skip the featured gallery item - it's the same as main image
        if (item.classList.contains('product-page-new__gallery-item--featured')) {
          return;
        }
        const img = item.querySelector('.product-page-new__gallery-img');
        if (img && img.src) {
          images.push({
            src: img.src.replace(/_\d+x\d+/, '').replace(/width=\d+/, 'width=1200'),
            alt: img.alt || 'Product image'
          });
        }
      });
      
      return images;
    }
    
    function openGalleryLightbox(startIndex = 0) {
      const images = getAllGalleryImages();
      if (images.length === 0) return;
      
      let lightbox = document.querySelector('.main-gallery-lightbox');
      if (!lightbox) {
        lightbox = document.createElement('div');
        lightbox.className = 'main-gallery-lightbox';
        lightbox.innerHTML = `
          <button class="main-gallery-lightbox__close" aria-label="Close">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
          <button class="main-gallery-lightbox__prev" aria-label="Previous">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>
          <button class="main-gallery-lightbox__next" aria-label="Next">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
          <div class="main-gallery-lightbox__track">
            <div class="main-gallery-lightbox__container"></div>
          </div>
          <div class="main-gallery-lightbox__counter"></div>
        `;
        document.body.appendChild(lightbox);
        
        const track = lightbox.querySelector('.main-gallery-lightbox__track');
        const container = lightbox.querySelector('.main-gallery-lightbox__container');
        const prevBtn = lightbox.querySelector('.main-gallery-lightbox__prev');
        const nextBtn = lightbox.querySelector('.main-gallery-lightbox__next');
        const closeBtn = lightbox.querySelector('.main-gallery-lightbox__close');
        const counter = lightbox.querySelector('.main-gallery-lightbox__counter');
        
        let currentIndex = 0;
        let touchStartX = 0;
        let touchEndX = 0;
        let isDragging = false;
        
        function updateLightbox(index) {
          currentIndex = Math.max(0, Math.min(images.length - 1, index));
          container.style.transform = `translateX(-${currentIndex * 100}%)`;
          counter.textContent = `${currentIndex + 1} / ${images.length}`;
          
          // Update button states
          prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
          prevBtn.disabled = currentIndex === 0;
          nextBtn.style.opacity = currentIndex === images.length - 1 ? '0.5' : '1';
          nextBtn.disabled = currentIndex === images.length - 1;
        }
        
        function navigate(direction) {
          if (direction === 'prev' && currentIndex > 0) {
            updateLightbox(currentIndex - 1);
          } else if (direction === 'next' && currentIndex < images.length - 1) {
            updateLightbox(currentIndex + 1);
          }
        }
        
        // Populate images
        images.forEach((img, index) => {
          const imgEl = document.createElement('img');
          imgEl.src = img.src;
          imgEl.alt = img.alt;
          imgEl.className = 'main-gallery-lightbox__image';
          container.appendChild(imgEl);
        });
        
        // Swipe handlers
        track.addEventListener('touchstart', (e) => {
          touchStartX = e.touches[0].clientX;
          isDragging = true;
        }, { passive: true });
        
        track.addEventListener('touchmove', (e) => {
          if (isDragging) {
            touchEndX = e.touches[0].clientX;
          }
        }, { passive: true });
        
        track.addEventListener('touchend', () => {
          if (isDragging) {
            const diff = touchStartX - touchEndX;
            if (Math.abs(diff) > 50) {
              if (diff > 0 && currentIndex < images.length - 1) {
                navigate('next');
              } else if (diff < 0 && currentIndex > 0) {
                navigate('prev');
              }
            }
            isDragging = false;
          }
        });
        
        // Mouse drag
        let mouseStartX = 0;
        let isMouseDragging = false;
        
        track.addEventListener('mousedown', (e) => {
          mouseStartX = e.clientX;
          isMouseDragging = true;
          e.preventDefault();
        });
        
        track.addEventListener('mousemove', (e) => {
          if (isMouseDragging) {
            const diff = mouseStartX - e.clientX;
            if (Math.abs(diff) > 50) {
              if (diff > 0 && currentIndex < images.length - 1) {
                navigate('next');
                isMouseDragging = false;
              } else if (diff < 0 && currentIndex > 0) {
                navigate('prev');
                isMouseDragging = false;
              }
            }
          }
        });
        
        document.addEventListener('mouseup', () => {
          isMouseDragging = false;
        });
        
        // Button handlers
        prevBtn.addEventListener('click', () => navigate('prev'));
        nextBtn.addEventListener('click', () => navigate('next'));
        closeBtn.addEventListener('click', closeLightbox);
        
        // Close on background click (anywhere except the image and buttons)
        lightbox.addEventListener('click', (e) => {
          // Don't close if clicking on image, buttons, or counter
          const clickedImage = e.target.closest('.main-gallery-lightbox__image');
          const clickedButton = e.target.closest('button');
          const clickedCounter = e.target.closest('.main-gallery-lightbox__counter');
          
          if (!clickedImage && !clickedButton && !clickedCounter) {
            // Clicking on background, track, or container - close the lightbox
            closeLightbox();
          }
        });
        
        // Keyboard navigation
        document.addEventListener('keydown', handleKeyDown);
        function handleKeyDown(e) {
          if (!lightbox.classList.contains('active')) return;
          if (e.key === 'ArrowLeft') navigate('prev');
          if (e.key === 'ArrowRight') navigate('next');
          if (e.key === 'Escape') closeLightbox();
        }
        
        function closeLightbox() {
          lightbox.classList.remove('active');
          document.body.style.overflow = '';
          document.removeEventListener('keydown', handleKeyDown);
        }
        
        window.closeGalleryLightbox = closeLightbox;
      }
      
      // Update images and show lightbox
      const galleryImages = getAllGalleryImages();
      const container = lightbox.querySelector('.main-gallery-lightbox__container');
      const counter = lightbox.querySelector('.main-gallery-lightbox__counter');
      const prevBtn = lightbox.querySelector('.main-gallery-lightbox__prev');
      const nextBtn = lightbox.querySelector('.main-gallery-lightbox__next');
      
      // Update container with current images
      container.innerHTML = '';
      galleryImages.forEach((imgData) => {
        const imgEl = document.createElement('img');
        imgEl.src = imgData.src;
        imgEl.alt = imgData.alt;
        imgEl.className = 'main-gallery-lightbox__image';
        container.appendChild(imgEl);
      });
      
      // Update to start index
      const targetIndex = Math.max(0, Math.min(galleryImages.length - 1, startIndex));
      container.style.transform = `translateX(-${targetIndex * 100}%)`;
      counter.textContent = `${targetIndex + 1} / ${galleryImages.length}`;
      prevBtn.style.opacity = targetIndex === 0 ? '0.5' : '1';
      nextBtn.style.opacity = targetIndex === galleryImages.length - 1 ? '0.5' : '1';
      
      // Store current index for navigation
      if (!lightbox.dataset.currentIndex) {
        lightbox.dataset.currentIndex = '0';
      }
      lightbox.dataset.currentIndex = targetIndex.toString();
      lightbox.dataset.totalImages = galleryImages.length.toString();
      
      // Show lightbox
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    
    // Add click handlers
    if (mainImage) {
      mainImage.addEventListener('click', () => openGalleryLightbox(0));
    }
    
    let galleryIndex = 1; // Start at 1 (0 is main featured image)
    galleryItems.forEach((item) => {
      const img = item.querySelector('.product-page-new__gallery-img');
      if (!img) return;
      
      // Featured gallery item opens at index 0 (same as main image)
      if (item.classList.contains('product-page-new__gallery-item--featured')) {
        img.addEventListener('click', () => {
          openGalleryLightbox(0);
        });
        return;
      }
      
      // Other gallery items
      const currentIndex = galleryIndex;
      img.addEventListener('click', () => {
        openGalleryLightbox(currentIndex);
      });
      galleryIndex++;
    });
  }
  
  // Initialize main gallery lightbox
  initMainGalleryLightbox();
  
  // Initialize size gallery
  initSizeGallery();

  // Handle color selection
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      
      const productId = this.dataset.productId;
      const productUrl = this.dataset.productUrl;
      const currentProductId = productPage.dataset.currentProductId || productPage.dataset.productId;
      
      // Don't reload if clicking the same product
      if (productId === currentProductId) return;
      
      // Show loading overlay immediately for instant feedback
      const loadingOverlay = document.createElement('div');
      loadingOverlay.className = 'product-color-loading';
      loadingOverlay.innerHTML = `
        <div style="
          width: 40px;
          height: 40px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #000;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        "></div>
        <style>
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        </style>
      `;
      loadingOverlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.95);
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.2s ease-in;
      `;
      document.body.appendChild(loadingOverlay);
      
      // Fade in loading overlay
      requestAnimationFrame(() => {
        loadingOverlay.style.opacity = '1';
      });
      
      // Prefetch the page for faster loading
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = productUrl || `/products/${this.dataset.productHandle}`;
      document.head.appendChild(link);
      
      // Small delay to show loading state, then navigate
      setTimeout(() => {
        // If no URL, construct it from handle
        if (!productUrl) {
          const productHandle = this.dataset.productHandle;
          if (productHandle) {
            window.location.href = `/products/${productHandle}`;
          }
          return;
        }
        
        // Navigate to the product URL
        window.location.href = productUrl;
      }, 50);
    });
  });

  // Handle size button clicks - wait for product data to be available
  sizeButtons.forEach(btn => {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const sizeValue = this.dataset.sizeValue;
      const optionName = this.dataset.optionName;
      const sizeIndex = this.dataset.sizeIndex;
      
      // Always wait for product data to be available
      let dataToUse = currentProductData;
      
      // If not available, wait for the promise
      if (!dataToUse) {
        try {
          dataToUse = await productDataPromise;
          if (dataToUse) {
            currentProductData = dataToUse;
          }
        } catch (e) {}
      }
      
      // If still no data, try fetching directly
      if (!dataToUse) {
        const currentHandle = productPage.dataset.currentProductHandle || productPage.dataset.productHandle;
        if (currentHandle) {
          try {
            dataToUse = await fetchProductData(currentHandle);
            if (dataToUse) {
              currentProductData = dataToUse;
            }
          } catch (e) {}
        }
      }
      
      // Handle the size selection
      if (dataToUse) {
          // Skip image update in selectSizeInProduct since we handle it separately
          selectSizeInProduct(sizeValue, optionName, dataToUse, true);
          if (sizeIndex !== undefined) {
            updateSizeImage(sizeIndex, dataToUse);
          }
      }
    });
  });

  // Format money helper - use Shopify's money format
  function formatMoney(cents) {
    // Try to use Shopify's money format if available
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    // Fallback to Intl formatter
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  // Size gallery is now pre-rendered in Liquid - no initialization needed

  // Note: We're not using history.pushState, so no need to handle popstate events
  
  
  // ============================================
  // Recently Viewed Products Functionality
  // ============================================
  
  // Track current product as recently viewed
  function trackRecentlyViewed() {
    if (!originalProductHandle || !originalProductId) return;
    
    const recentlyViewedKey = 'tectle_recently_viewed';
    let recentlyViewed = [];
    
    try {
      const stored = localStorage.getItem(recentlyViewedKey);
      if (stored) {
        recentlyViewed = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Error reading recently viewed:', e);
    }
    
    // Remove current product if it exists
    recentlyViewed = recentlyViewed.filter(item => item.handle !== originalProductHandle);
    
    // Add current product to the beginning
    recentlyViewed.unshift({
      handle: originalProductHandle,
      id: originalProductId,
      timestamp: Date.now()
    });
    
    // Keep only last 20 products
    recentlyViewed = recentlyViewed.slice(0, 20);
    
    try {
      localStorage.setItem(recentlyViewedKey, JSON.stringify(recentlyViewed));
    } catch (e) {
      console.error('Error saving recently viewed:', e);
    }
  }
  
  // Fetch product data by handle
  async function fetchProductByHandle(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return null;
      return await response.json();
    } catch (e) {
      console.error('Error fetching product:', e);
      return null;
    }
  }
  
  // Get random products from all collections (using same approach as recommended section)
  async function getRandomProducts(excludeHandles, count) {
    const randomProducts = [];
    
    // Use Shopify's product recommendations API as fallback
    try {
      const response = await fetch(`/recommendations/products.json?product_id=${originalProductId}&limit=${count * 2}`);
      if (response.ok) {
        const data = await response.json();
        if (data.products && data.products.length > 0) {
          const availableProducts = data.products.filter(
            p => !excludeHandles.includes(p.handle) && p.available
          );
          
          // Shuffle and take random products
          const shuffled = availableProducts.sort(() => 0.5 - Math.random());
          randomProducts.push(...shuffled.slice(0, count));
        }
      }
    } catch (e) {
      console.error('Error fetching recommendations:', e);
    }
    
    // If we still need more products, try fetching from featured collections
    if (randomProducts.length < count) {
      const commonCollections = ['all', 'featured', 'new-arrivals', 'bestsellers'];
      
      for (const collectionHandle of commonCollections) {
        if (randomProducts.length >= count) break;
        
        try {
          const response = await fetch(`/collections/${collectionHandle}/products.json?limit=50`);
          if (!response.ok) continue;
          const data = await response.json();
          
          if (data.products && data.products.length > 0) {
            const availableProducts = data.products.filter(
              p => !excludeHandles.includes(p.handle) && p.available && !randomProducts.find(rp => rp.handle === p.handle)
            );
            
            // Shuffle and take random products
            const shuffled = availableProducts.sort(() => 0.5 - Math.random());
            randomProducts.push(...shuffled.slice(0, count - randomProducts.length));
          }
        } catch (e) {
          console.error('Error fetching collection:', e);
        }
      }
    }
    
    return randomProducts.slice(0, count);
  }
  
  // Render product card
  function renderProductCard(product) {
    if (!product) return '';
    
    // Handle different product data formats (from .js endpoint vs .json endpoint)
    let imageUrl = '';
    if (product.featured_image) {
      imageUrl = typeof product.featured_image === 'string' 
        ? product.featured_image 
        : product.featured_image.src || product.featured_image.url || '';
    } else if (product.images && product.images.length > 0) {
      imageUrl = typeof product.images[0] === 'string' 
        ? product.images[0] 
        : product.images[0].src || product.images[0].url || '';
    }
    
    // Convert to full image URL if needed
    let imageSrc = imageUrl;
    if (imageSrc && !imageSrc.startsWith('http') && !imageSrc.startsWith('//')) {
      imageSrc = imageSrc.startsWith('/') ? imageSrc : `/${imageSrc}`;
    }
    
    const productUrl = product.url || `/products/${product.handle}`;
    const title = product.title || '';
    
    // Format price - handle different formats
    let formattedPrice = '$0.00';
    if (product.variants && product.variants.length > 0) {
      const price = product.variants[0].price || product.variants[0].price_min || 0;
      formattedPrice = new Intl.NumberFormat('en-US', { 
        style: 'currency', 
        currency: product.variants[0].price_currency || 'USD' 
      }).format(price / 100);
    } else if (product.price) {
      const price = typeof product.price === 'number' ? product.price : parseInt(product.price);
      formattedPrice = new Intl.NumberFormat('en-US', { 
        style: 'currency', 
        currency: 'USD' 
      }).format(price / 100);
    }
    
    return `
      <div class="recommended-product-card" style="position: relative; background: transparent; display: flex; flex-direction: column; align-items: flex-start; border: none; margin: 0; padding: 0;">
        <a href="${productUrl}" style="text-decoration: none; color: inherit; display: block; width: 100%; border: none; position: relative;">
          <div class="recommended-product-image" style="position: relative; width: 100%; padding-top: 125%; background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 50%, #f5f5f5 100%); display: flex; align-items: center; justify-content: center; border: none; margin-bottom: 0;">
            ${imageSrc ? `<img 
              src="${imageSrc}" 
              alt="${title}"
              style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; padding: 0;"
              loading="lazy"
            />` : ''}
            <div class="recommended-product-info" style="position: absolute; bottom: 0; left: 0; right: 0; padding: 16px; background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 50%, transparent 100%); text-align: left; margin: 0;">
              <h3 style="margin: 0 0 4px 0; font-size: 14px; font-weight: 400; line-height: 1.4; color: #fff;">${title}</h3>
              <div style="font-size: 14px; font-weight: 400; color: #fff; margin: 0;">
                ${formattedPrice}
              </div>
            </div>
          </div>
        </a>
      </div>
    `;
  }
  
  // Load and display recently viewed products
  async function loadRecentlyViewed() {
    const recentlyViewedGrid = document.querySelector('.product-recently-viewed-grid[data-content="recently-viewed"]');
    
    if (!recentlyViewedGrid) return;
    
    const recentlyViewedKey = 'tectle_recently_viewed';
    let recentlyViewed = [];
    
    try {
      const stored = localStorage.getItem(recentlyViewedKey);
      if (stored) {
        recentlyViewed = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Error reading recently viewed:', e);
    }
    
    // Remove current product from recently viewed
    recentlyViewed = recentlyViewed.filter(item => item.handle !== originalProductHandle);
    
    // Get up to 4 recently viewed products
    const recentlyViewedHandles = recentlyViewed.slice(0, 4).map(item => item.handle);
    const excludeHandles = [originalProductHandle, ...recentlyViewedHandles];
    
    // Fetch recently viewed products
    const recentlyViewedProducts = [];
    for (const item of recentlyViewed.slice(0, 4)) {
      const product = await fetchProductByHandle(item.handle);
      if (product) {
        recentlyViewedProducts.push(product);
      }
    }
    
    // Fill remaining slots with random products
    const remainingCount = 4 - recentlyViewedProducts.length;
    if (remainingCount > 0) {
      const randomProducts = await getRandomProducts(excludeHandles, remainingCount);
      recentlyViewedProducts.push(...randomProducts);
    }
    
    // Render products (limit to 4)
    if (recentlyViewedProducts.length > 0) {
      recentlyViewedGrid.innerHTML = recentlyViewedProducts.slice(0, 4).map(renderProductCard).join('');
    }
  }
  
  // Tab switching functionality
  function initProductTabs() {
    const tabs = document.querySelectorAll('.product-section-tab');
    const contents = document.querySelectorAll('.product-section-content');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetTab = tab.dataset.tab;
        
        // Update active tab
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        
        // Update active content
        contents.forEach(content => {
          content.classList.remove('active');
          if (content.dataset.content === targetTab) {
            content.classList.add('active');
          }
        });
      });
    });
  }
  
  // Track current product and load recently viewed
  trackRecentlyViewed();
  
  // Initialize tabs
  initProductTabs();
  
  // Load recently viewed items after main content is ready (non-blocking)
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => loadRecentlyViewed(), { timeout: 3000 });
  } else {
    setTimeout(loadRecentlyViewed, 1500);
  }
  
  // ============================================
  // Header Hide/Show on Scroll Past Gallery
  // ============================================
  
  // Header always visible - functionality disabled
  function initHeaderHideOnScroll() {
    const header = document.querySelector('#site-header[data-sticky-header]');
    
    if (!header) return;
    
    // Keep header always visible
          header.style.setProperty('opacity', '1', 'important');
          header.style.pointerEvents = 'auto';
  }
  
  // Initialize header - always visible
  setTimeout(() => {
    initHeaderHideOnScroll();
  }, 500);
  
  // Helper to check if we're on mobile
  function isMobileView() {
    return window.innerWidth <= 1024;
  }
  
  // Dynamic sticky position - adjusts top value as user scrolls down
  function initDynamicStickyPosition() {
    // Skip on mobile
    if (isMobileView()) return;
    
    const infoBlock = productPage.querySelector('.product-page-new__info');
    const infoContainer = productPage.querySelector('.product-page-new__info-container');
    const productBlock = productPage; // productPage IS already .product-page-new element
    const galleryContainer = productPage.querySelector('.product-page-new__gallery-container');
    
    if (!infoBlock || !infoContainer || !productBlock) {
      return;
    }
    
    // Force sticky positioning with multiple methods - do this FIRST
    infoBlock.style.cssText += 'position: -webkit-sticky !important; position: sticky !important; align-self: flex-start !important; top: 0px !important;';
    
    // Fix ALL parent overflow issues that break sticky
    function fixAllParents() {
      let parent = infoContainer;
      let level = 0;
      const fixedParents = [];
      
      while (parent && level < 10 && parent !== document.body) {
        const style = window.getComputedStyle(parent);
        
        // Fix overflow
        if (style.overflow !== 'visible' && style.overflow !== '') {
          parent.style.setProperty('overflow', 'visible', 'important');
          fixedParents.push({ element: parent, property: 'overflow', level });
        }
        
        // Fix overflow-y
        if (style.overflowY !== 'visible' && style.overflowY !== '') {
          parent.style.setProperty('overflow-y', 'visible', 'important');
          fixedParents.push({ element: parent, property: 'overflow-y', level });
        }
        
        // Fix overflow-x if it's hidden
        if (style.overflowX === 'hidden') {
          parent.style.setProperty('overflow-x', 'visible', 'important');
        }
        
        // Remove transforms that break sticky
        if (style.transform && style.transform !== 'none') {
          parent.style.setProperty('transform', 'none', 'important');
        }
        
        parent = parent.parentElement;
        level++;
      }
      
    }
    
    // Make container tall enough for sticky to work
    function updateContainerHeight() {
      if (!infoContainer) return;
      
      // Get gallery height if available
      let galleryHeight = 0;
      if (galleryContainer) {
        galleryHeight = Math.max(
          galleryContainer.offsetHeight || 0,
          galleryContainer.scrollHeight || 0,
          galleryContainer.getBoundingClientRect().height || 0
        );
      }
      
      // Get content height
      const contentHeight = Math.max(
        infoBlock.scrollHeight || 0,
        infoBlock.offsetHeight || 0,
        500
      );
      
      // Calculate target height - match gallery height exactly for proper synchronization
      const viewportHeight = window.innerHeight || 800;
      let targetHeight = galleryHeight || 0;
      
      // If gallery height is not available yet, use fallback
      if (targetHeight < 500) {
        targetHeight = Math.max(
          viewportHeight * 3,
          contentHeight + 2000,
          3000 // Absolute minimum
        );
      } else {
        // Match gallery height exactly for synchronized scrolling
        targetHeight = galleryHeight;
      }
      
      // Set container height to match gallery
            infoContainer.style.setProperty('min-height', targetHeight + 'px', 'important');
            infoContainer.style.setProperty('height', targetHeight + 'px', 'important');
            
    }
    
    // Initial setup
    fixAllParents();
    updateContainerHeight();
    
    // Update container height when images load
    if (galleryContainer) {
      const images = galleryContainer.querySelectorAll('img');
    images.forEach(img => {
      if (img.complete) {
          setTimeout(() => {
            updateContainerHeight();
            updateStickyPosition();
          }, 400);
      } else {
        img.addEventListener('load', () => {
            setTimeout(() => {
              updateContainerHeight();
              updateStickyPosition();
            }, 400);
        }, { once: true });
      }
    });
    
      // Watch for gallery size changes
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => {
          updateContainerHeight();
          fixAllParents();
          updateStickyPosition();
        });
        resizeObserver.observe(galleryContainer);
      }
    }
    
    // Dynamic sticky position adjustment - synchronized with gallery height
    let ticking = false;
    let lastTop = 0;
    
    function getHeights() {
      if (!galleryContainer || !infoBlock) return { galleryHeight: 0, infoHeight: 0, viewportHeight: 0 };
      
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      
      // Get gallery height
      const galleryHeight = Math.max(
        galleryContainer.offsetHeight || 0,
        galleryContainer.scrollHeight || 0,
        galleryContainer.getBoundingClientRect().height || 0
      );
      
      // Get info block height
      const infoHeight = Math.max(
        infoBlock.scrollHeight || 0,
        infoBlock.offsetHeight || 0,
        infoBlock.getBoundingClientRect().height || 0
      );
      
      return { galleryHeight, infoHeight, viewportHeight };
    }
    
    function updateStickyPosition() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const productTop = productBlock.offsetTop;
      const scrollProgress = scrollTop - productTop;
      
      // Get current heights
      const { galleryHeight, infoHeight, viewportHeight } = getHeights();
      
      // Only calculate if we have valid heights
      if (galleryHeight <= 0 || infoHeight <= 0 || viewportHeight <= 0) {
        ticking = false;
        return;
      }
      
      // Calculate scrollable distances
      // Gallery scrollable distance: from start until bottom hits viewport bottom
      const galleryScrollableDistance = Math.max(0, galleryHeight - viewportHeight);
      
      // Info block needs to move down by this amount to sync with gallery
      const infoBlockMovementNeeded = Math.max(0, infoHeight - viewportHeight);
      
      // Calculate sticky offset based on scroll progress
      let stickyOffset = 0;
      
      if (scrollProgress > 0 && galleryScrollableDistance > 0) {
        // Calculate progress ratio (0 to 1)
        const progressRatio = Math.min(1, scrollProgress / galleryScrollableDistance);
        
        // Calculate offset: negative to move down as we scroll
        // As progressRatio goes from 0 to 1, offset goes from 0 to -infoBlockMovementNeeded
        stickyOffset = -progressRatio * infoBlockMovementNeeded;
        
        // Clamp to reasonable bounds
        stickyOffset = Math.max(-infoBlockMovementNeeded, Math.min(0, stickyOffset));
      }
      
      // Update if changed
      const newTop = Math.round(stickyOffset);
      if (newTop !== lastTop) {
        infoBlock.style.setProperty('top', stickyOffset + 'px', 'important');
        lastTop = newTop;
      }
      
      ticking = false;
    }
    
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateStickyPosition);
        ticking = true;
      }
    }
    
    // Initial position
    updateStickyPosition();
    
    // Listen for scroll
    window.addEventListener('scroll', onScroll, { passive: true });
    
    // Update on resize
    window.addEventListener('resize', () => {
      updateContainerHeight();
      fixAllParents();
      updateStickyPosition();
    }, { passive: true });
  }
  
  // Initialize multiple times to catch timing issues
  setTimeout(() => {
    initDynamicStickyPosition();
  }, 300);
  
  setTimeout(() => {
    initDynamicStickyPosition();
  }, 800);
  
  setTimeout(() => {
    initDynamicStickyPosition();
  }, 1500);
  
  setTimeout(() => {
    initDynamicStickyPosition();
  }, 3000);
  
  window.addEventListener('load', () => {
    setTimeout(() => {
      initDynamicStickyPosition();
    }, 100);
  });
  
  // Also try on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initDynamicStickyPosition, 500);
    });
  }
  
  // Handle scroll priority: info block scrolls first, then page scrolls
  // Works even when scrolling outside the info block container
  let wheelHandlerAttached = false;
  let wheelHandler = null;
  
  function initInfoBlockScrollPriority() {
    // Only attach listener once
    if (wheelHandlerAttached && wheelHandler) {
      return;
    }
    
    // Remove old handler if it exists (shouldn't happen, but safety check)
    if (wheelHandler) {
      document.removeEventListener('wheel', wheelHandler, { capture: true });
      window.removeEventListener('wheel', wheelHandler, { capture: true });
      document.body.removeEventListener('wheel', wheelHandler, { capture: true });
    }
    
    wheelHandler = (e) => {
      // Skip custom scroll handling on mobile
      if (isMobileView()) return;
      
      // Skip custom scroll handling if cart sidebar is open
      const cartSidebar = document.getElementById('site-cart-sidebar');
      if (cartSidebar && cartSidebar.classList.contains('sidebar--opened')) {
        return; // Allow normal scroll when cart is open
      }
      
      // Also check if body has sidebar-opened class
      if (document.body.classList.contains('sidebar-opened')) {
        return; // Allow normal scroll when any sidebar is open
      }
      
      // Always find info block fresh to ensure it exists
      const infoBlock = document.querySelector('.product-page-new__info');
      if (!infoBlock) {
        return; // Allow normal scroll if info block doesn't exist
      }
      
      // Ensure info block is actually in the DOM and has dimensions
      if (!infoBlock.offsetParent && infoBlock.style.display === 'none') {
        return; // Element is hidden, allow normal scroll
      }
      
      // Only intercept scroll when mouse is actually over the product-page-new element
      const productBlock = document.querySelector('.product-page-new');
      if (productBlock) {
        const productRect = productBlock.getBoundingClientRect();
        
        // Get mouse position from the wheel event
        const mouseX = e.clientX;
        const mouseY = e.clientY;
        
        // Check if mouse is within the product block bounds
        const isMouseInProductBlock = (
          mouseX >= productRect.left &&
          mouseX <= productRect.right &&
          mouseY >= productRect.top &&
          mouseY <= productRect.bottom
        );
        
        // If mouse is not over the product block, allow normal scroll
        if (!isMouseInProductBlock) {
          return; // Mouse is outside product area - normal scroll for recommendations/footer
        }
      }
      
      // Check if info block is scrollable - get fresh values each time
      const scrollTop = infoBlock.scrollTop;
      const scrollHeight = infoBlock.scrollHeight;
      const clientHeight = infoBlock.clientHeight;
      const maxScrollTop = Math.max(0, scrollHeight - clientHeight);
      
      // If content doesn't overflow, allow normal scroll
      if (scrollHeight <= clientHeight || maxScrollTop <= 0) {
        return;
      }
      
      const deltaY = e.deltaY;
      const scrollingDown = deltaY > 0;
      const scrollingUp = deltaY < 0;
      
      // Calculate how much scroll movement we can apply to info block (1.2x speed multiplier)
      const totalScrollAmount = Math.abs(deltaY);
      const infoBlockScrollAmount = totalScrollAmount * 1.2; // 1.2x scroll speed for info block
      
      let actualInfoBlockScroll = 0;
      let remainingScrollForPage = totalScrollAmount;
      
      // If scrolling down - apply 30% to info block if it can scroll more
      if (scrollingDown) {
        const distanceFromBottom = maxScrollTop - scrollTop;
        
        // If info block can scroll more, apply 30% of scroll to it
        if (distanceFromBottom > 0.1) {
          // Calculate how much we can actually scroll the info block (up to 30% of total)
          const canScrollAmount = Math.min(infoBlockScrollAmount, distanceFromBottom);
          actualInfoBlockScroll = canScrollAmount;
          remainingScrollForPage = totalScrollAmount - actualInfoBlockScroll;
          
          // Scroll the info block
          infoBlock.scrollTop = Math.min(scrollTop + actualInfoBlockScroll, maxScrollTop);
        }
        // If at bottom, all scroll goes to page (remainingScrollForPage = totalScrollAmount)
      }
      
      // If scrolling up - apply 30% to info block if it can scroll more
      if (scrollingUp) {
        // If we're not at the top, apply 30% of scroll to info block
        if (scrollTop > 1) {
          // Calculate how much we can actually scroll the info block (up to 30% of total)
          const canScrollAmount = Math.min(infoBlockScrollAmount, scrollTop);
          actualInfoBlockScroll = canScrollAmount;
          remainingScrollForPage = totalScrollAmount - actualInfoBlockScroll;
          
          // Scroll the info block
          infoBlock.scrollTop = Math.max(scrollTop - actualInfoBlockScroll, 0);
        }
        // If at top, all scroll goes to page (remainingScrollForPage = totalScrollAmount)
      }
      
      // If we scrolled the info block, we need to prevent the default scroll
      // and manually scroll the page by the remaining amount
      if (actualInfoBlockScroll > 0) {
          e.preventDefault();
          e.stopPropagation();
        
        // Manually scroll the page by the remaining amount (70% or whatever remains)
        const scrollDirection = scrollingDown ? 1 : -1;
        window.scrollBy({
          top: remainingScrollForPage * scrollDirection,
          behavior: 'auto' // Instant scroll to match wheel scroll behavior
          });
          
          return false;
      }
      
      // If info block can't scroll (at limits), allow normal page scroll
      // Don't prevent default, let the page scroll naturally
    };
    
    // Add wheel event listener to document (captures all scrolls, even outside window)
    // Use capture phase to catch events before they bubble
    document.addEventListener('wheel', wheelHandler, { passive: false, capture: true });
    
    // Also add to window as backup
    window.addEventListener('wheel', wheelHandler, { passive: false, capture: true });
    
    // Also add to body as another backup
    document.body.addEventListener('wheel', wheelHandler, { passive: false, capture: true });
    
    wheelHandlerAttached = true;
    
    // Also handle touch events for mobile
    let touchStartY = 0;
    let touchStartScrollTop = 0;
    let isTouching = false;
    
    const isInfoBlockInView = () => {
      const infoBlock = productPage.querySelector('.product-page-new__info');
      if (!infoBlock) return false;
      const rect = infoBlock.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    };
    
    const handleTouchStart = (e) => {
      if (!isInfoBlockInView()) return;
      
      const infoBlock = productPage.querySelector('.product-page-new__info');
      if (!infoBlock) return;
      
      touchStartY = e.touches[0].clientY;
      touchStartScrollTop = infoBlock.scrollTop;
      isTouching = true;
    };
    
    const handleTouchMove = (e) => {
      if (!isTouching || !isInfoBlockInView()) return;
      
      const infoBlock = productPage.querySelector('.product-page-new__info');
      if (!infoBlock) return;
      
      const touchY = e.touches[0].clientY;
      const deltaY = touchStartY - touchY;
      
      const scrollTop = infoBlock.scrollTop;
      const scrollHeight = infoBlock.scrollHeight;
      const clientHeight = infoBlock.clientHeight;
      const maxScrollTop = scrollHeight - clientHeight;
      
      // If content doesn't overflow, allow normal scroll
      if (scrollHeight <= clientHeight) {
        isTouching = false;
        return;
      }
      
      const isAtTop = scrollTop <= 1;
      const isAtBottom = scrollTop >= maxScrollTop - 1;
      
      // If scrolling down (pulling up) and not at bottom
      if (deltaY < 0 && !isAtBottom) {
        e.preventDefault();
        const newScrollTop = Math.min(touchStartScrollTop - deltaY, maxScrollTop);
        infoBlock.scrollTop = newScrollTop;
        return false;
      }
      
      // If scrolling up (pulling down) and not at top
      if (deltaY > 0 && !isAtTop) {
        e.preventDefault();
        const newScrollTop = Math.max(touchStartScrollTop - deltaY, 0);
        infoBlock.scrollTop = newScrollTop;
        return false;
      }
      
      // If at limits, allow normal page scroll
    };
    
    const handleTouchEnd = () => {
      isTouching = false;
    };
    
    window.addEventListener('touchstart', handleTouchStart, { passive: true });
    window.addEventListener('touchmove', handleTouchMove, { passive: false });
    window.addEventListener('touchend', handleTouchEnd, { passive: true });
  }
  
  // Initialize scroll priority - ensure it runs
  initInfoBlockScrollPriority();
  
  // Also initialize after a short delay to ensure it's set
  setTimeout(initInfoBlockScrollPriority, 100);
  
  // Also initialize on load
  window.addEventListener('load', initInfoBlockScrollPriority);
  
  // Also try on DOMContentLoaded if needed
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfoBlockScrollPriority);
  } else {
    initInfoBlockScrollPriority();
  }
  
  // Removed scroll debug logging for performance
  
  
  // Hide recommended section initially, show after product content loads
  const recommendedSection = document.querySelector('.product-recommendations-section');
  if (recommendedSection) {
    recommendedSection.style.display = 'none';
    recommendedSection.style.visibility = 'hidden';
    recommendedSection.style.opacity = '0';
    
    // Show recommended section after product content is loaded
    // Wait for main product images and content to be ready
    const checkProductLoaded = () => {
      const mainImage = document.querySelector('.product-page-new__featured-img');
      const galleryImages = document.querySelectorAll('.product-page-new__gallery-img');
      const productInfo = document.querySelector('.product-page-new__info');
      
      // Check if main product content is loaded
      const mainImageLoaded = mainImage && (mainImage.complete || mainImage.naturalWidth > 0);
      const hasGalleryImages = galleryImages.length > 0;
      const hasProductInfo = productInfo && productInfo.offsetHeight > 0;
      
      if (mainImageLoaded && hasGalleryImages && hasProductInfo) {
        // Product content is loaded, show recommended section
        recommendedSection.style.display = '';
        recommendedSection.style.visibility = '';
        recommendedSection.style.opacity = '';
        recommendedSection.style.transition = 'opacity 0.3s ease-in';
        setTimeout(() => {
          recommendedSection.style.opacity = '1';
        }, 10);
      } else {
        // Check again after a short delay
        setTimeout(checkProductLoaded, 100);
      }
    };
    
    // Start checking after a short delay to allow initial render
    setTimeout(checkProductLoaded, 200);
    
    // Also check on window load as fallback
    window.addEventListener('load', () => {
      setTimeout(() => {
        recommendedSection.style.display = '';
        recommendedSection.style.visibility = '';
        recommendedSection.style.opacity = '1';
        recommendedSection.style.transition = 'opacity 0.3s ease-in';
      }, 100);
    });
  }
  
  // Hide footer initially, show after product content loads
  const footer = document.querySelector('footer, [class*="footer"], footer-group, [id*="footer"], [data-section-type*="footer"]');
  
  const showFooterWhenReady = () => {
    const mainImage = document.querySelector('.product-page-new__featured-img');
    const galleryImages = document.querySelectorAll('.product-page-new__gallery-img');
    const productInfo = document.querySelector('.product-page-new__info');
    
    // Check if main product content is loaded
    const mainImageLoaded = mainImage && (mainImage.complete || mainImage.naturalWidth > 0);
    const hasGalleryImages = galleryImages.length > 0;
    const hasProductInfo = productInfo && productInfo.offsetHeight > 0;
    
    if (mainImageLoaded && hasGalleryImages && hasProductInfo) {
      // Product content is loaded, show footer
      document.body.classList.add('page-loaded');
    } else {
      // Check again after a short delay
      setTimeout(showFooterWhenReady, 100);
    }
  };
  
  // Start checking after a short delay
  setTimeout(showFooterWhenReady, 200);
  
  // Also show footer on window load as fallback
  window.addEventListener('load', () => {
    setTimeout(() => {
      document.body.classList.add('page-loaded');
    }, 100);
  });
  
  // Load other images lazily
  setTimeout(() => {
    const allImages = productPage.querySelectorAll('img');
    allImages.forEach(img => {
      if (img.loading !== 'lazy' && !img.classList.contains('product-page-new__featured-img')) {
        img.loading = 'lazy';
      }
    });
  }, 100);
  
  // Size image lightbox is now handled by openSizeImageLightbox() in the gallery code
  
  // Mobile Gallery Swipe & Pagination
  function initMobileGallery() {
    const mobileGallery = productPage.querySelector('[data-mobile-gallery]');
    const galleryDots = productPage.querySelectorAll('[data-gallery-dots] .product-page-new__gallery-dot');
    const sliderThumb = productPage.querySelector('[data-gallery-slider-thumb]');
    const sliderTrack = productPage.querySelector('.product-page-new__gallery-slider-track');
    
    if (!mobileGallery) return;
    
    const galleryItems = mobileGallery.querySelectorAll('.product-page-new__gallery-item');
    if (galleryItems.length === 0) return;
    
    const totalImages = galleryItems.length;
    
    // Set initial slider thumb width
    if (sliderThumb && totalImages > 0) {
      const thumbWidth = 100 / totalImages;
      sliderThumb.style.width = thumbWidth + '%';
    }
    
    // Update slider live on scroll (real-time as you swipe)
    mobileGallery.addEventListener('scroll', () => {
      const scrollLeft = mobileGallery.scrollLeft;
      const itemWidth = mobileGallery.offsetWidth;
      const maxScroll = mobileGallery.scrollWidth - itemWidth;
      
      // Update slider thumb position live
      if (sliderThumb && totalImages > 1) {
        const thumbWidth = 100 / totalImages;
        const maxThumbPosition = 100 - thumbWidth;
        const scrollProgress = maxScroll > 0 ? scrollLeft / maxScroll : 0;
        const thumbPosition = scrollProgress * maxThumbPosition;
        sliderThumb.style.left = thumbPosition + '%';
      }
      
      // Update dots (can be slightly debounced since it's less critical)
      const activeIndex = Math.round(scrollLeft / itemWidth);
      galleryDots.forEach((dot, index) => {
        dot.classList.toggle('active', index === activeIndex);
      });
    }, { passive: true });
    
    // Click on dots to navigate
    galleryDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const itemWidth = mobileGallery.offsetWidth;
        mobileGallery.scrollTo({
          left: index * itemWidth,
          behavior: 'smooth'
        });
      });
    });
  }
  
  // Initialize mobile gallery
  initMobileGallery();
  
  // Re-initialize on resize (in case switching between mobile/desktop)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initMobileGallery, 200);
  });
  
  // Map size names to variant values (how they appear in size buttons)
  const sizeToVariant = {
    'Medium': 'M',
    'Large': 'L',
    'XLarge': 'XL',
    'XLarge+': 'XL+',
    'XLarge++': 'XL++',
    'XXLarge': 'XXL',
    'XXLarge+': 'XXL+'
  };
  
  // Reverse map - variant values to size names
  const variantToSize = {
    'M': 'Medium',
    'L': 'Large',
    'XL': 'XLarge',
    'XL+': 'XLarge+',
    'XL++': 'XLarge++',
    'XXL': 'XXLarge',
    'XXL+': 'XXLarge+'
  };
  
  // Update dimension block active state based on selected size
  function updateDimensionBlockSelection(selectedValue) {
    const dimensionsContent = document.querySelector('.dimensions-content');
    if (!dimensionsContent) return;
    
    const blocks = dimensionsContent.querySelectorAll('.dimension-block[data-size-name]');
    const sizeButtons = document.querySelectorAll('[data-size-selector] .product-page-new__size-btn');
    
    // Find which button index is active/selected
    let activeIndex = -1;
    sizeButtons.forEach((btn, idx) => {
      const btnVal = btn.dataset.sizeValue || btn.textContent.trim();
      if (btnVal === selectedValue || btn.classList.contains('active')) {
        activeIndex = idx;
      }
    });
    
    // Update dimension blocks by matching index
    blocks.forEach((block, idx) => {
      if (idx === activeIndex) {
        block.classList.add('active');
      } else {
        block.classList.remove('active');
      }
    });
  }
  
  // Expose function globally so size buttons can call it
  window.updateDimensionBlockSelection = updateDimensionBlockSelection;
  
  // Format dimensions content - clean up, make size names bold, and make blocks clickable
  function formatDimensionsContent() {
    const dimensionsContent = document.querySelector('.dimensions-content');
    
    if (!dimensionsContent || dimensionsContent.dataset.formatted === 'true') {
      return;
    }
    
    // Size names to look for (order matters - longest first)
    const sizeNames = ['XXLarge+', 'XXLarge', 'XLarge++', 'XLarge+', 'XLarge', 'Large', 'Medium'];
    
    // Get all p tags
    const pTags = Array.from(dimensionsContent.querySelectorAll('p'));
    
    pTags.forEach((p, index) => {
      const text = p.textContent.trim();
      
      // Skip empty paragraphs
      if (!text) {
        p.remove();
        return;
      }
      
      // Find which size name this paragraph starts with
      let matchedSize = null;
      for (const size of sizeNames) {
        if (text.startsWith(size)) {
          matchedSize = size;
          break;
        }
      }
      
      if (matchedSize) {
        // Get the inner HTML and clean it up
        let html = p.innerHTML;
        
        // Remove leading <br> tags
        html = html.replace(/^(\s*<br\s*\/?>\s*)+/gi, '');
        
        // Replace the size name with bold version
        // Handle cases where + might be on separate line or after br
        const escapedName = matchedSize.replace(/\+/g, '\\+');
        
        // First, try to match the size name directly (with optional trailing <br>)
        const directRegex = new RegExp(`^(${escapedName})(<br\\s*/?>)?`, 'i');
        if (directRegex.test(html)) {
          html = html.replace(directRegex, `<strong>${matchedSize}</strong>`);
        } else {
          // Handle case where + might be separated by <br>
          // e.g., "XLarge<br>+" should become "<strong>XLarge+</strong>"
          const baseSize = matchedSize.replace(/\+/g, '');
          const plusCount = (matchedSize.match(/\+/g) || []).length;
          
          if (plusCount > 0) {
            // Match base size followed by <br> and plus signs (and optional trailing <br>)
            const brPlusPattern = new RegExp(`^(${baseSize})(<br\\s*/?>\\s*)(\\+{${plusCount}})(<br\\s*/?>)?`, 'gi');
            html = html.replace(brPlusPattern, `<strong>${matchedSize}</strong>`);
          }
        }
        
        // Extract dimensions (everything after the size name)
        // First, remove the size name part (with strong tag)
        let dimensionsText = html;
        const sizeNamePattern = new RegExp(`<strong>${escapedName}</strong>\\s*(<br\\s*/?>\\s*)?`, 'i');
        dimensionsText = dimensionsText.replace(sizeNamePattern, '').trim();
        
        // If no dimensions found, try to extract from the full HTML
        if (!dimensionsText || dimensionsText === html) {
          // Extract everything after the closing strong tag
          const afterStrong = html.split(/<\/strong>/i);
          if (afterStrong.length > 1) {
            dimensionsText = afterStrong.slice(1).join('</strong>').replace(/^<br\s*\/?>\s*/i, '').trim();
          }
        }
        
        // Create collapsible structure
        const wrapper = document.createElement('div');
        wrapper.className = 'dimension-block';
        wrapper.dataset.sizeName = matchedSize;
        
        // Create header with title and arrow
        const header = document.createElement('div');
        header.className = 'dimension-block__header';
        header.innerHTML = `
          <span class="dimension-block__title"><strong>${matchedSize}</strong></span>
          <span class="dimension-block__arrow-wrapper">
            <svg class="dimension-block__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 5v14M5 12h14"/>
            </svg>
          </span>
        `;
        
        // Create collapsible content
        const content = document.createElement('div');
        content.className = 'dimension-block__content';
        content.innerHTML = dimensionsText;
        content.style.display = 'none'; // Start collapsed
        
        // Flag to prevent multiple toggles
        let isToggling = false;
        
        // Function to close all other blocks
        const closeAllOtherBlocks = () => {
          const allBlocks = dimensionsContent.querySelectorAll('.dimension-block');
          allBlocks.forEach(block => {
            if (block !== wrapper) {
              const blockContent = block.querySelector('.dimension-block__content');
              if (blockContent) {
                blockContent.style.display = 'none';
                block.classList.remove('expanded');
              }
            }
          });
        };
        
        // Function to select the size
        const selectSize = () => {
          const sizeButtons = Array.from(document.querySelectorAll('[data-size-selector] .product-page-new__size-btn'));
          const dimBlocks = Array.from(dimensionsContent.querySelectorAll('.dimension-block[data-size-name]'));
          
          // Find my index among dimension blocks
          const myIndex = dimBlocks.indexOf(wrapper);
          
          // Click the corresponding size button
          if (myIndex >= 0 && sizeButtons[myIndex]) {
            sizeButtons[myIndex].click();
          }
        };
        
        // Click on title area - only selects size, doesn't toggle dropdown
        const titleElement = header.querySelector('.dimension-block__title');
        titleElement.addEventListener('click', function(e) {
          e.stopPropagation();
          selectSize();
        });
        
        // Click on arrow wrapper - only toggles dropdown
        const arrowWrapper = header.querySelector('.dimension-block__arrow-wrapper');
        arrowWrapper.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Prevent multiple rapid toggles
          if (isToggling) return;
          isToggling = true;
          
          // Close ALL other dimension blocks first (force close - synchronous)
          const allBlocks = dimensionsContent.querySelectorAll('.dimension-block');
          allBlocks.forEach(block => {
            if (block !== wrapper) {
              const blockContent = block.querySelector('.dimension-block__content');
              if (blockContent) {
                blockContent.style.display = 'none';
                block.classList.remove('expanded');
              }
            }
          });
          
          // Toggle this block only
          const isCurrentlyExpanded = wrapper.classList.contains('expanded');
          if (isCurrentlyExpanded) {
            content.style.display = 'none';
            wrapper.classList.remove('expanded');
          } else {
            content.style.display = 'block';
            wrapper.classList.add('expanded');
          }
          
          // Reset toggle flag after a brief delay
          setTimeout(() => {
            isToggling = false;
          }, 100);
        });
        
        // Click on header area (but not title or arrow) - selects size
        header.addEventListener('click', function(e) {
          // Only handle if clicking on the header itself, not title or arrow
          if (e.target === header) {
            e.stopPropagation();
            selectSize();
          }
        });
        
        wrapper.appendChild(header);
        wrapper.appendChild(content);
        
        // Replace the paragraph with the new structure
        p.parentNode.replaceChild(wrapper, p);
      } else {
        // Not a size block - remove it
        p.remove();
      }
    });
    
    dimensionsContent.dataset.formatted = 'true';
    
    // Sync with currently selected size button on initial load
    const activeButton = document.querySelector('[data-size-selector] .product-page-new__size-btn.active');
    if (activeButton) {
      const activeValue = activeButton.dataset.sizeValue || activeButton.textContent.trim();
      updateDimensionBlockSelection(activeValue);
    }
  }
  
  // Run on page load
  setTimeout(formatDimensionsContent, 500);
  
  // Run when any expandable is opened
  document.addEventListener('click', function(e) {
    if (e.target.closest('.product-page-new__expandable-header')) {
      setTimeout(formatDimensionsContent, 100);
    }
  });
});

